import { render, staticRenderFns } from "./backoffice-procedimento-hospital-dia.vue?vue&type=template&id=4e7cd106"
import script from "./backoffice-procedimento-hospital-dia.vue?vue&type=script&lang=ts"
export * from "./backoffice-procedimento-hospital-dia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports